import type {
  V1UserDocument,
  V1UserImage,
  V1UserMessage,
} from '@/generated/hooks/rain/models';

import type { IRainSendAttachment } from '../hooks/types';

/**
 * Builds the wire-level `V1UserMessage` from the UI's unified attachment form.
 * The API splits images and documents into two sibling fields, so this maps the
 * single `IRainSendAttachment[]` array accordingly. Shared by the editor's
 * `sendMessageToThread` and by NewDraftChat's send-at-source so both produce an
 * identical payload.
 */
export function buildRainUserMessage(
  content: string,
  attachments: IRainSendAttachment[] = [],
): V1UserMessage {
  const images: V1UserImage[] = [];
  const documents: V1UserDocument[] = [];
  for (const att of attachments) {
    if (att.kind === 'image') {
      images.push(
        att.detail ? { uri: att.uri, detail: att.detail } : { uri: att.uri },
      );
    } else {
      documents.push({ uri: att.uri, filename: att.filename });
    }
  }
  const message: V1UserMessage = { content: content.trim() };
  if (images.length > 0) message.images = images;
  if (documents.length > 0) message.documents = documents;
  return message;
}
